import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAndParseRss } from "../../services/newsService";
import { RootState } from "../store";

interface NewsItem {
    title: string;
    link: string;
    pubDate: string;
    contentSnippet: string;
}

export interface NewsState {
    items: NewsItem[];
    loading: boolean;
    error: string | null;
}

const initialState: NewsState = {
    items: [],
    loading: false,
    error: null,
};

export const fetchNews = createAsyncThunk<NewsItem[], void, { rejectValue: string }>(
    "news/fetchNews",
    async (_, { rejectWithValue }) => {
        try {
            const items = await fetchAndParseRss();
            return items;
        } catch (error) {
            if (error instanceof Error) {
                return rejectWithValue(error.message);
            }
            return rejectWithValue("An unknown error occurred");
        }
    },
);

const newsSlice = createSlice({
    name: "news",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNews.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const selectNews = (state: RootState): NewsState => state.news;

export default newsSlice.reducer;
